import Vue from 'vue';
import Router from 'vue-router';
import Cookies from 'vue-cookies';
import Home from '@/components/Home';
import Signin from '@/components/Signin';
import Camps from '@/components/Camps';
import Programs from '@/components/Programs';
import SportProgram from '@/components/SportProgram';
import Orders from '@/components/Orders';
import ActivateAccount from '@/components/ActivateAccount';

Vue.use(Router);

window.application = Cookies.get('application');
//window.host = 'http://localhost:5000';
window.host = 'https://backend.sportlane.com';

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/signin',
      name: 'signin',
      component: Signin
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/camps',
      name: 'camps',
      component: Camps,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/programs',
      name: 'programs',
      component: Programs,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/programs/:id',
      component: SportProgram,
      props: (route) => ({ id: route.params.id }),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/orders',
      name: 'Orders',
      component: Orders,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/account/activate',
      name: 'ActivateAccount',
      component: ActivateAccount
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (Cookies.get('jwt') == null) {
      next({
        path: '/signin',
        params: { nextUrl: to.fullPath }
      });
    } else {
      next();
    }
    next();
  } else {
    next();
  }
});

export default router;
